<template>
    <div class="loginverify_wrap">
        <van-nav-bar
                title=""
                left-text=""
                right-text=""
                left-arrow
                @click-left="onClickLeft"
                @click-right="onClickRight"
        >
            <template #left>
                <van-icon name="arrow-left" color="#000000" />
                <span>Volver</span>
            </template>
        </van-nav-bar>
        <div class="loginverify_top">
            <div class="loginverify_title">Crea una contraseña nueva</div>
            <div class="loginverify_mobile">
                {{lookmobile}}
            </div>
        </div>

        <div class="loginverify_middle">
            <div class="loginverify_motp">Crea contrasena de 6 digitos</div>

            <div class="loginverify_mcode">
                <div class="prize_other_dvview">
                    <div class="prize_other_inps">
                        <div class="youxi_form_wrap">
                            <!-- inputBoxview -->
                            <div class="inputBox">
                                <div v-for="(item, index) in captchas" :key="index"
                                     :class="fouceIndex == index ? 'scale-1px-fouce' : 'scale-1px'">
                                    <input
                                            v-model="item.num"
                                            :id="'captcha' + index"
                                            @input="inputFinish(index)"
                                            @focus="adjust(index)"
                                            @keydown="inputDirection(index, $event)"
                                            class="auth-b"
                                            type="tel"
                                            maxlength="1"
                                    />
                                </div>
                            </div>

                        </div>
                    </div>
                </div>


            </div>
            <div class="loginverify_mdesc" v-if="verifyCode">Código de verificación incorrecto</div>
            <div class="loginverify_msend" @click="backSms">
                <span :class="!isSendcode ? 'active' : '' ">Iniciar sesión con el Código de verificación</span> <template v-if="isSendcode">（{{codeval}}）</template>
            </div>
            <div class="loginverify_msend_view" v-if="isSendcode">
                <div class="loginverify_msend_mask"></div>
            </div>

        </div>

        <div class="loginverify_footer" >
            <van-button round color="#19A95C" block style="height: 1.222222rem;" @click="goLogin">
                <span style="font-weight: 500;">Guardar contrasena</span>
            </van-button>
            <div style="width: 100%; height: 10px;"></div>
            <!--<div class="loginverify_password">
                <span>Saltar</span>
            </div>-->
        </div>
    </div>
</template>

<script>

    import { Toast, Dialog } from 'vant';
    import { loadingShow, loadingHide } from '@/utils/loading'
    import { setAccessToken } from '@/utils/auth'
    import { loginPassword } from '@/api/login';


    let clock = null;

    export default{
        data() {
            return {
                fouceIndex: null,
                captchas: [{ num: "" }, { num: "" }, { num: "" }, { num: "" }, { num: "" }, { num: ""}],
                captchaCode: '',
                mobile: null,
                mobile_exist: false,
                lookmobile: null,
                nums: 60,
                isSendcode: false,
                codeval: '',
                verifyCode: false,
            }
        },
        mounted() {
            let mobile = this.getQueryString('mobile');
            let mobile_exist = this.getQueryString('mobile_exist');
            let password_exist = this.getQueryString('password_exist');
            console.log(mobile)
            console.log(mobile_exist)
            console.log(password_exist)

            this.mobile_exist = mobile_exist;

            let lookmobile = mobile.substring(0, 3)+"****"+mobile.substr(mobile.length-4);

            this.mobile = mobile;
            this.lookmobile = lookmobile;

            let isSendcode = window.localStorage.getItem('isSendcode');

            if(!isSendcode){
                window.localStorage.setItem('isSendcode', true);
            }
        },
        methods: {
            onClickLeft() {
                this.$router.back();
            },
            onClickRight() {

            },
            getQueryString(name) {
                var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
                var r = window.location.search.substr(1).match(reg);
                if (r != null) {
                    return unescape(r[2]);
                }
                return null;
            },
            // 输入框聚焦
            adjust(index) {
                let _this = this;
                console.log(index)
                let dom = document.getElementById("captcha" + this.activeInput);
                if (index != this.activeInput && dom) {
                    dom.focus();
                }
                this.fouceIndex = index;
            },
            // 前后输入方向
            inputDirection(index, event) {
                let value = this.captchas[index].num;
                if (event.keyCode == 8 && value == "") {
                    let dom = document.getElementById("captcha" + (index - 1));
                    this.activeInput = index - 1;
                    if (dom) dom.focus();
                }
                if (event.keyCode != 8 && value != "") {
                    let dom = document.getElementById("captcha" + (index + 1));
                    this.activeInput = index + 1;
                    if (dom) dom.focus();
                }
            },
            // 输入框
            inputFinish(index) {
                let value = this.captchas[index].num;
                this.activeInput = value ? index + 1 : index - 1;
                let dom = document.getElementById("captcha" + this.activeInput);
                if (dom) dom.focus();
                if (index == this.captchas.length - 1) {
                    this.captchaCode = this.captchas.map((a) => a.num).join("");
                    if (this.captchaCode.length == 4) {
                        console.log("captchaCode", this.captchaCode);
                    }
                }
            },
            doLoop() {
                this.nums--;
                if(this.nums > 0){
                    this.codeval = this.nums + 's';
                } else {
                    clearInterval(clock);
                    clock = null;
                    this.isSendcode = false;
                    this.codeval = '';
                    this.nums = 60;
                    window.localStorage.setItem('isSendcode', false);
                }
            },
            verificationCode() {
                console.log('获取验证码')
                clearInterval(clock);
                clock = null;
                this.codeval = '';
                this.nums = 60;
                let _this = this;
                this.verifyCode = false;
                if(this.mobile){
                    //console.log(111111)
                    let getmobile = this.mobile;

                    let firstStr = getmobile.substr(0, 1);

                    let isflag = false;

                    if(firstStr == 1){ //1开始 11位
                        if(getmobile.length == 11){
                            isflag = true;
                        } else {
                            isflag = false;
                        }

                    } else {//非1 10位
                        if(getmobile.length == 10){
                            isflag = true;
                        } else {
                            isflag = false;
                        }
                    }

                    if(isflag){
                        this.getCommomParams('smscode')
                        this.smsCodeeFirstLoan();
                    } else {
                        loadingHide()
                        Toast('Formato incorrecto del número móvil') //手机号码格式错误
                    }

                } else {
                    loadingHide()
                    Toast('Por favor ingrese el número de teléfono móvil') //请输入手机号
                }
            },
            backSms() {
                this.$router.back();
                /*let usemobile = this.mobile
                this.$router.push({
                    path: '/loanpage/setpassword',
                    query: {
                        mobile: usemobile
                    }
                })*/
            },
            commonparamsFun() {
                let commonparams = {
                    uta_lrm_jev: '0a97411e-7216-4c25-84dc-7f8853d3bec1',
                    wxq_fcy_qvd: 'Superpwa',
                    uqf_sqc_rdb: '1.1',
                    aif_efb_bad: '59',
                    wji_snl_bsh: '',
                    gsg_vcr_spf: '', // 8819a314331fd1288124da582385a03c
                    frg_wpc_sbq: '3',
                    pik_hit_iyd: '',
                    lmj_uvg_ljo: '1745390990025-6134478757746957813',
                    jym_rsn_icx: 'sdk_gphone64_arm64',
                    hvc_ann_cnl: '',
                    tul_pwd_xwf: '-1',
                    alh_sjc_mfj: '14',
                    ecc_eda_hca: 'c641c796-2008-4cf4-8476-c8a79e2fe001',
                    aer_rbs_pxr: '0',
                    xbe_nxb_kfr: '-1',
                    vaz_mtl_mvo: 'y55ldjvCPvthbL2NOju7KqOVStXQbnn43tcJGH2_4EA=',
                    mqh_qef_wkr: 'e47a0dR6QfeQU_r3Aee0wR:APA91bHbd4HGJ8Z3b_VILG48DcmJRRUpCNzZkyFCrHQVeMNYgPYCAf3anAjIK_vXScUzIO-E8d_2ad-okfNjmV8-hhyHB2MHAAAQOCogtLeCzr3ODdIjOas',
                    wdb_igv_mvy: '',
                    dkx_hed_raz: '',
                    yoj_net_zzx: 'google',
                    doe_ody_zty: '9E48AF9EFA33FCB114BD45436BE17380',
                    csb_ggc_uyo: 'android',
                    ega_caf_hbe: '1',
                    rdn_sge_rrm: '',
                    kvk_jjy_tsv: 'Superpwa',
                    ckn_emo_hfg: new Date().getTime(),  //request_time
                    aaa_off_csl: '', //noise
                    zzm_yya_hqb: '', //access_token
                    bac_fcc_gdc: '', //signature
                };

                return commonparams;
            },
            goLogin() {
                let _this = this;
                this.verifyCode = false;
                let commonparams = this.commonparamsFun();
                if(this.captchaCode && this.captchaCode.length == 6){
                    console.log('验证码输入成功')

                    let usemobile = `+52${this.mobile}`;
                    let usepassword = this.captchaCode;
                    let postData = {
                        iyc_kae_ixp: usemobile,
                        yyq_wkd_kfd: usepassword,
                        vcb_jde_jwa: 0,
                        ...commonparams,
                    };

                    // loadingShow();
                    /*loginPassword(postData).then(res => {
                        console.log(res)
                    }, error => {

                    });*/

                    /*setTimeout(() => {
                        loadingHide();

                        let access_token = 'ec637fd06732df08fb442acdc4bf457a';
                        setAccessToken(access_token);

                        this.$router.replace({
                            path: '/loanpage/applyhome',
                        })
                    }, 2000);*/

                } else {
                    console.log(this.captchaCode)
                    Toast('Por favor introduzca el captcha') //请输入验证码
                }
            },
        }
    }
</script>

<style less scoped>
    .loginverify_wrap{
        width: 100%;
        height: auto;
    }
    .loginverify_top{
        width: 100%;
        height: 2.722222rem;
        box-sizing: border-box;
        padding-top: 0.555556rem;
    }
    .loginverify_title{
        width: 100%;
        height: 0.444444rem;
        font-size: 0.444444rem;
        font-weight: 400;
        color: #333333;
        line-height: 0.444444rem;
        text-align: center;
    }
    .loginverify_mobile{
        width: 100%;
        height: 0.388889rem;
        font-size: 0.388889rem;
        font-weight: 400;
        color: #999999;
        line-height: 0.388889rem;
        text-align: center;
        margin-top: 0.25rem;
    }
    .loginverify_middle{
        width: 92.22%;
        height: auto;
        margin: 0 auto;
    }
    .loginverify_motp{
        width: 100%;
        height: 0.611111rem;
        font-size: 12px;
        font-weight: 400;
        color: #666666;
        line-height: 12px;
    }
    .loginverify_mcode{
        width: 100%;
        height: 1.222222rem;
    }
    .loginverify_mdesc{
        width: 100%;
        height: 0.916667rem;
        font-size: 13px;
        font-weight: 400;
        color: #FB4840;
        line-height: 0.916667rem;
    }
    .loginverify_msend{
        width: 100%;
        height: 1.0rem;
        box-sizing: border-box;
        padding-top: 0.555556rem;
        font-size: 0.388889rem;
        font-weight: 400;
        color: #333333;
    }
    .loginverify_msend .active{
        color: #333333;
    }
    .loginverify_msend_view{
        width: 100%;
        height: 1px;
        position: relative;
    }
    .loginverify_msend_mask{
        width: 100%;
        height: 1.1rem;
        position: absolute;
        left: 0;
        top: -1rem;
    }
    .loginverify_msend span{
        color: #999999;
        text-decoration: underline;
    }
    .loginverify_footer{
        width: 92.22%;
        height: auto;
        margin: 1.666667rem auto;
    }
    .prize_other_dvview{
        width: 100%;
        height: auto;
        margin: 0 auto;
    }
    .prize_other_inps{
        width: 100%;
    }
    .prize_oinps_view{
        width: 100%;
        height: 1.222222rem;
    }
    .prize_oinps_view input{
        display: block;
        width: 100%;
        height: 1.0rem;
        outline: none;
        background: #DEEEFF;
        border-radius: 0.166667rem;
        border: 1px solid #FFFFFF;
        box-sizing: border-box;
        padding-left: 0.266667rem;
        font-size: 0.373333rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #954F0A;
    }
    .youxi_form_wrap{
        width: 100%;
        height: 1.25rem;
    }
    .inputBox {
        width: 100%;
        height: 1.222222rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .auth-b {
        width: 1.2rem;
        height: 1.111111rem;
        box-sizing: border-box;
        border-radius: 0.166667rem;
        border: 1px solid #FFFFFF;
        outline: none;
        line-height: 1.222222rem;
        text-align: center;
        font-size: 0.666667rem;
    }
    .inputBoxview{

    }
    .scale-1px{
        position: relative;
        border:none;
    }
    .scale-1px:after{
        content: '';
        position: absolute;
        left: 0;
        bottom: 0;
        background: #C7C7C7;
        width: 100%;
        height: 1px;
        -webkit-transform: scaleY(0.5);
        transform: scaleY(0.5);
        -webkit-transform-origin: 0 0;
        transform-origin: 0 0;
    }
    .scale-1px-fouce{
        position: relative;
        border:none;
    }
    .scale-1px-fouce:after{
        content: '';
        position: absolute;
        left: 0;
        bottom: 0;
        background: #19A95C;
        width: 100%;
        height: 1px;
        -webkit-transform: scaleY(0.5);
        transform: scaleY(0.5);
        -webkit-transform-origin: 0 0;
        transform-origin: 0 0;
    }
    .scale-1px-error{
        position: relative;
        border:none;
    }
    .scale-1px-error:after{
        content: '';
        position: absolute;
        left: 0;
        bottom: 0;
        background: #FB4840;
        width: 100%;
        height: 1px;
        -webkit-transform: scaleY(0.5);
        transform: scaleY(0.5);
        -webkit-transform-origin: 0 0;
        transform-origin: 0 0;
    }
    .inputBoxview .scale-1px:after{
        background: #FB4840;
    }
    .inputBoxview .scale-1px-fouce:after{
        background: #FB4840;
    }
    .loginverify_password{
        width: 100%;
        height: auto;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .loginverify_password span{
        font-size: 14px;
        color: #333333;
    }
</style>

<style less>
    .van-dialog{
        width: 76.39vw;
        border-radius: 0.277778rem;
    }
    .van-dialog__confirm, .van-dialog__confirm:active{
        background: #19A95C;
    }
</style>